'use client';

import { ReactNode } from 'react';
import { usePathname } from 'next/navigation';
import MobileLayout from '@/components/layout/Mobile';
import { TransitionProvider } from '@/components/Mobile/Transition/TransitionContext.jsx';
import SwipeTransition from '@/components/Mobile/Transition/SwipeTransition';
import { MobileShellProvider } from '@/components/Mobile/MobileShellContext';
import DirectoryMobile from '@/components/Mobile/Directory';
import type { ProjectModel } from '@/lib/models/Project';

interface Props {
  children: ReactNode;
  projects: ProjectModel[];
}

export function MobileShell({ children, projects }: Props) {
  // Blog routes run their own expand/collapse animation language and don't
  // want the global SwipeTransition slide-and-fade layered on top. Other
  // mobile routes (home Swiper, project detail) keep the existing behavior.
  const pathname = usePathname();
  const skipSwipeTransition = pathname?.startsWith('/blog') ?? false;

  return (
    <TransitionProvider>
      <MobileShellProvider>
        <MobileLayout>
          {skipSwipeTransition ? children : <SwipeTransition>{children}</SwipeTransition>}
        </MobileLayout>
        <DirectoryMobile projects={projects} />
      </MobileShellProvider>
    </TransitionProvider>
  );
}
